module.exports = global["surveylab_page_textbox"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./textbox.ts");